import React, { lazy } from 'react';
export const Footer = () => {
  return <footer className="w-full py-16 md:py-24 bg-white relative z-10" data-id="element-33">
      <div className="max-w-[1200px] mx-auto px-6" data-id="element-34">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_3fr] gap-[60px] lg:gap-[60px] mb-10" data-id="element-35">
          {/* Logo */}
          <div className="footer-brand" data-id="element-36">
            <img alt="Certainly" loading="lazy" width="120" height="32" decoding="async" data-nimg="1" className="h-8 w-auto" style={{
            color: 'transparent'
          }} src="https://cdn.magicpatterns.com/uploads/kNffUvNzmsMTFtNpE4mF9e/forest-green-certainly.svg" data-id="element-37" />
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-38">
            {/* Company */}
            <div data-id="element-39">
              <h4 className="text-[13.6px] font-medium text-[#111928] mb-4" data-id="element-40">
                Company
              </h4>
              <ul className="space-y-3" data-id="element-41">
                <li data-id="element-42">
                  <a href="https://certainlyhealth.com/about" className="text-[13.6px] text-[#6B7280] opacity-70 hover:opacity-100 transition-opacity" data-id="element-43">
                    About Us
                  </a>
                </li>
                <li data-id="element-44">
                  <a href="mailto:support@certainlyhealth.com" className="text-[13.6px] text-[#6B7280] opacity-70 hover:opacity-100 transition-opacity" data-id="element-45">
                    Contact Us
                  </a>
                </li>
                <li data-id="element-46">
                  <a href="https://coach.certainlyhealth.com" className="text-[13.6px] text-[#6B7280] opacity-70 hover:opacity-100 transition-opacity" data-id="element-47">
                    Become a Coach
                  </a>
                </li>
              </ul>
            </div>

            {/* Resources */}
            <div data-id="element-48">
              <h4 className="text-[13.6px] font-medium text-[#111928] mb-4" data-id="element-49">
                Resources
              </h4>
              <ul className="space-y-3" data-id="element-50">
                <li data-id="element-51">
                  <a href="https://certainlyhealth.com/privacy" className="text-[13.6px] text-[#6B7280] opacity-70 hover:opacity-100 transition-opacity" data-id="element-52">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-53">
                  <a href="https://certainlyhealth.com/tos" className="text-[13.6px] text-[#6B7280] opacity-70 hover:opacity-100 transition-opacity" data-id="element-54">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-55">
                  <a href="https://certainlyhealth.com/sitemap" className="text-[13.6px] text-[#6B7280] opacity-70 hover:opacity-100 transition-opacity" data-id="element-56">
                    Sitemap
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-6 border-t border-[#E5E7EB]" data-id="element-57">
          <div className="text-sm opacity-60" data-id="element-58">
            © {new Date().getFullYear()} Certainly Health, Inc. All rights
            reserved.
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4" data-id="element-59">
            {/* Instagram */}
            <a href="https://www.instagram.com/certainlyhealth" target="_blank" rel="noopener noreferrer" className="opacity-60 hover:opacity-100 transition-opacity" aria-label="Instagram" data-id="element-60">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" data-id="element-61">
                
              </svg>
            </a>

            {/* TikTok */}
            <a href="https://www.tiktok.com/@certainlyhealth" target="_blank" rel="noopener noreferrer" className="opacity-60 hover:opacity-100 transition-opacity" aria-label="TikTok" data-id="element-62">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" data-id="element-63">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" fill="rgb(107,114,128)" data-id="element-64" />
              </svg>
            </a>

            {/* Twitter */}
            <a href="https://twitter.com/CertainlyHealth" target="_blank" rel="noopener noreferrer" className="opacity-60 hover:opacity-100 transition-opacity" aria-label="Twitter" data-id="element-65">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" data-id="element-66">
                
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};